<template>
  <div id="home">

    <div class="banner"></div>

    <v-container id="main">

      <section id="center-section">
        <h1 class="primary-text">Discover How Much Your Business Can Save!</h1>
        <p class="secondary-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos suscipit fuga adipisci laboriosam non sint dolores dolorem velit obcaecati tempora consequatur, laborum id. Dolorum quasi praesentium quaerat, laudantium aut dolorem.</p>
        
        <!-- <v-alert
          :value="error !== null"
          type="warning"
        >
          {{ error }}
        </v-alert>
        
        <v-card-actions class="justify-center">
          <v-select
              v-model="companySize"
              :items="companySizes"
              label="Company Size"
          ></v-select>
        </v-card-actions> -->

        <!-- <v-btn color="primary" @click="submitCompanySize"><b>GET STARTED</b></v-btn> -->
        <v-btn large class="cta-btn" color="primary" @click="$emit('show-costs');"><b>GET STARTED</b></v-btn>
        <br>
      </section>

      <section id="information">
          <div class="blurb">
            <div class="blurb-icon">
              <i class="far fa-clock fa-5x"></i>
            </div>
            <div class="blurb-text">
              <h1>15 Minutes</h1>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis odio error modi sapiente reiciendis itaque voluptas enim tempora, nisi unde quod nulla culpa delectus, voluptatibus quibusdam. Odio voluptas aperiam alias.</p>
            </div>
          </div>

          <div class="blurb">
            <div class="blurb-icon">
              <i class="fas fa-dollar-sign fa-5x"></i>
            </div>
            <div  class="blurb-text">
              <h1>Save Money</h1>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. In sit error enim soluta, expedita sunt aliquam officiis a accusamus. Cupiditate ipsum consequatur sequi fugiat, neque omnis odio magni quae nobis.</p>
            </div>
          </div>

          <div class="blurb">
            <div class="blurb-icon">
              <i class="far fa-chart-bar fa-5x"></i>
            </div>
            <div class="blurb-text">
              <h1>Compare to Industry</h1>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum quos nemo facilis nesciunt sed, quisquam qui doloremque saepe dolorem, atque reiciendis eaque sunt illum! At accusantium architecto excepturi sint repudiandae.</p>
            </div>
          </div>
      </section>

    </v-container>

  </div>
</template>

<script>
export default {
  name: 'home',
  data: () => ({
    companySize: null,
    error: null,
    companySizes: [
      '1-9 Employees (Micro)',
      '10-49 Employees (Small)',
      '50-249 Employees (Medium)',
      '250+ Employees (Large)'
    ]
  }),
  methods: {
    submitCompanySize() {
      if (this.companySize) {
        this.$emit('show-costs', this.companySize);
      } else {
        this.error = 'A company size must be entered in order for us to give you the best results.'
      }
    }
  }
}

</script>

<style scoped>
.save {
  color: #1976d2;
}
.cta-btn {
  border-radius: 100px;
  box-shadow: 0 10px 20px -3px rgba(0, 0, 0, .2);
}
#home {
  display: flex;
  justify-content:  center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height:100%;
}

.banner {
  height: 30rem;
  width: 100%;
  background-image: url("../../public/images/blue-bg.jpg");
}

#center-section {
  background-color: white;
  border-radius: 15px;
  padding-top: 5%;
  padding-bottom: 5%;
  margin-top: -20rem;
  box-shadow: 0 10px 30px 0px rgba(0,0,0,.1);
}
.primary-text {
  font-size: 32px;
}

.secondary-text {
  font-size: 20px;
  margin: 0 4rem;
}
@media screen and (min-width: 320px) and (max-width: 800px) {
  .primary-text {
    margin: 0 10px;
  }
  .secondary-text {
    font-size: 20px;
    margin: 0;
  }
}

#home p {
  padding: 3rem;
}

#information {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  background: white;
  margin-top: 5rem;
  padding: 1rem;
  border-radius: 15px;
  box-shadow: 0 10px 30px 0px rgba(0,0,0,.1);
}

.blurb {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-around;
    padding: 1rem;
}

.blurb-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #1976d2;
}

.blurb-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 15px;
  padding: 1rem;
}

@media screen and (min-width: 320px) and (max-width: 800px){
  #information {
    flex-direction: column;
  }
}

</style>
